export const API_PATH_ApiTrafficStudyCopy = '/services/traffic-studies/apiTrafficStudyCopy';
